<template>
	<div class="calendar-plug" ref="calendar">
		<div class="header">
			<van-icon name="play-circle-o" class="arrow-left" @click="lastMonthClick" :style="{color:active==0?'#F62B34':''}"/>
			<span class="date">{{selectedYear}}年{{selectedMonth}}月</span>
			<van-icon name="play-circle-o" class="arrow-right" @click="nextMonthClick" :style="{color:active==1?'#F62B34':''}"/>
		</div>

		<div class="container">
			<div class="everyWeekDay">
				<span v-for="(item,index) in weekDays" class="weekday" :key="index">
					<span class="weekday" >{{item}}</span>
				</span>				
			</div>
			<div class="everyDay">
					<div class="days">
						<div v-for="(item) in defaultWeekday" class="day-item-wrap empty" :key="item.id">
							<div class="day-item">
								<!-- <span class="solar">{{lastMonthDay-defaultWeekday+item}}</span> -->
								<span class="solar"></span>
							</div>
						</div>
						<div v-for="(item) in dateArr" :key="item.id" class="day-item-wrap"  :class="{'currentDay':item.solar==currentDay&&currentMonth==selectedMonth&&currentYear==selectedYear,'selectedFlag':item.year==selectedDay.year&&item.month==selectedDay.month&&item.solar==selectedDay.day}" @click="selectDate({year:item.year,month:item.month,day:item.solar})">	
							<div class="day-item">
								<span class="solar">{{item.solar}}</span>
						
								<span class="color" :key="value.id" v-for="(value,index) in monthMeetingsDate"  :style="{background:backgroundColor[index]}" v-if="value.date.indexOf(item.solar)>-1">
									<b class="line-clamp-1">{{value.name}}</b>
								</span>																
							</div>
						</div>
					</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default{
		data(){
			return{
				active:1,
				currentYear:new Date().getFullYear(),      //当前年
				currentMonth:new Date().getMonth()+1,        //当前月
				currentDay:new Date().getDate(),           //代表今天
				currentWeekday:new Date().getDay(),       //今天周几
				defaultWeekday:'',                        //每个月1号对应的周几
				dayCount:0,            //这个月的天数
				weekdayCount:0,        //这个周有几天
				lastMonthDay:0,
				weekDays :[ "一", "二", "三", "四", "五", "六","日"],
				months :["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"],
				lastDays : [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
				selectedYear:'',      //选中的年份
				selectedMonth:'',     //选中的月份
				selectedDay:{},       //选中的日期
				dateArr:[],
				monthMeetings:[],      //本月会议
				monthMeetingsDate:[],       //本月会议日期
				backgroundColor:['#F62B34','#20AC11','#FAC02F','#2F79FF','#FF7F00','#9932CC','#FFC0CB','#F5DEB3','#00BFFF','#E6E6FA','#C1FFC1','#F62B34','#20AC11','#FAC02F','#2F79FF','#FF7F00','#9932CC','#FFC0CB','#F5DEB3','#00BFFF','#E6E6FA','#C1FFC1','#F62B34','#20AC11','#FAC02F','#2F79FF','#FF7F00','#9932CC','#FFC0CB','#F5DEB3','#00BFFF','#E6E6FA','#C1FFC1']
			}
		},

		mounted(){
			this.selectedYear=this.currentYear;
			this.selectedMonth=this.currentMonth;
			this.selectedDay={
				year:this.currentYear,
				month:this.currentMonth,
				day:this.currentDay
			}
			this.getThisMonthDay(this.selectedYear,this.selectedMonth);
			this.getThisWeekDay(this.selectedYear,this.selectedMonth,1);
			var date=new Date();
		},
		methods:{
			//初始化
			init(data){
				this.monthMeetingsDate=[];
				this.monthMeetings=data;
				let length=0;
				for(let j=0;j<data.length;j++){
					let str1=data[j].start_at;
					let str2=data[j].end_at;
					let arr1=this.dataScope(str1,str2);
					let arr2={
						name:data[j].calendar_title,
						date:[]
					};
					for(let j=0;j<arr1.length;j++){
						let dateArr=arr1[j].split('-');
						let date=new Date(dateArr[0],dateArr[1]-1,dateArr[2]);
						if(this.selectedMonth==date.getMonth()+1&&this.selectedYear==date.getFullYear()){
							arr2.date.push(date.getDate())
						}
					}
					this.monthMeetingsDate.push(arr2);

				}
				
					this.monthMeetingsDate.sort(function(a,b){
						    return b.date.length-a.date.length;
					})
					console.log(this.monthMeetingsDate)
			},
			//时间段内对应的日期
			dataScope(value1, value2) {  
			    var date1 =new Date(value1).getTime();  
			    var date2 =new Date(value2).getTime();
			    if (date1>date2) {  
			        var tempDate = date1;  
			        date1 = date2;  
			        date2 = tempDate;  
			    }  
			    var dateArr = [];  
			    var i = 0;  

			    while (date1<=date2) { 
			    	date1=new Date(date1);
		         	var dayStr =date1.getDate().toString();  
			        if(dayStr.length ==1){  
			             dayStr="0"+dayStr;  
			        }
			        dateArr[i] = date1.getFullYear() + "-" + (date1.getMonth() + 1) + "-"  
			                + dayStr;  
			        i++;   

			        date1.setDate(date1.getDate() + 1); 
			    }  
			    return dateArr;  
			},
			//选择日期
			selectDate(date){
				this.selectedDay={
					year:date.year,
					month:date.month,
					day:date.day
				}
				date.month=date.month<10?'0'+date.month:date.month;
				date.day=date.day<10?'0'+date.day:date.day;
				this.$emit('changeDay',date.year+'-'+date.month+'-'+date.day)
			},
			//判断是否是闰年
			isLeapYear:function (year){
				if(0==year%4&&((year%100!=0)||(year%400==0))){
					return true
				}
				return false;
			},
			//得到这个月的天数
			getThisMonthDay:function (year, month) {
				var dayCount = this.lastDays[month - 1];
				this.lastMonthDay=this.lastDays[month - 2];       //上个月的天数
				if ((month == 2) && this.isLeapYear(year)) {
					dayCount++;
				}
				this.dayCount=dayCount;
				let dateArr=[];
				for(let i=1;i<=dayCount;i++){
					let obj={};
					obj.solar=i;
					obj.month=month;
					obj.year=year;
					dateArr.push(obj);
				}
				this.dateArr=dateArr;
			},
			//得到上个月的天数
			getLastMonthDay(year, month){
				var dayCount = this.lastDays[month - 2];
				this.lastMonthDay=dayCount;
			},
			//得到周几(一般得到每个月1号是周几)
			getThisWeekDay:function (year, month, date) {
				console.log(month)
				var thisDate = new Date(year, month - 1, date-1);
				this.defaultWeekday=thisDate.getDay();
				console.log(this.defaultWeekday)
			},
			//切换上个月
			lastMonthClick(){
				this.active=0;
				this.monthMeetingsDate=[];    //将数据清空  以防数据变动  出现闪
				if(this.selectedMonth==1){
					this.selectedYear--;
					this.selectedMonth=12;
				}else{
					this.selectedMonth--;
				}
				this.reloadData();
			},
			//切换下一个月
			nextMonthClick(){
				this.active=1;
				this.monthMeetingsDate=[];   //将数据清空  以防数据变动  出现闪
				if(this.selectedMonth==12){
					this.selectedYear++;
					this.selectedMonth=1;
				}else{
					this.selectedMonth++;
				}
				this.reloadData();
			},

			//重新刷新数据
			reloadData(){
				this.getThisMonthDay(this.selectedYear,this.selectedMonth);
				this.getThisWeekDay(this.selectedYear,this.selectedMonth,1);	
				this.$emit('changeMonth',this.selectedMonth,this.selectedYear)			
			},
			cumWeekDayCounrt:function(date){
				var thisDate = new Date(this.selectedYear, this.selectedMonth-1, date);
				return thisDate.getDay();
			},
			


		}
	}
</script>
<style lang="scss">
	.calendar-plug{
		.header{
			transform: perspective(1000);
			background:#ededed;
			padding:14px 0;
			@include flex(row);
			justify-content:center;
			align-items:center;
			.arrow-left{
				transform: rotateY(180deg);
				-ms-transform:rotateY(180deg); 
   				-webkit-transform:rotateY(180deg); 
			}
			i{
				font-size:22px;
				color:#b1b2b3;
			}
			span.date{
				margin:0 40px;
				font-size:14px;
				color:$color-black;
				letter-spacing: 0.5px;
				font-weight:700;
			}
		}
		.container{
			.everyWeekDay{
				background:#ededed;
				@include flex(row);
				justify-content:space-between;
				.weekday{
					width:14.28%;
					text-align:center;
					color:#202020;
					line-height: 26px;
				}				
			}
			.everyDay{
				.days{
					@include flex(row);
					flex-wrap:wrap;
				}
				.empty{
						border-right:0px;
				}
				.day-item-wrap{
				  padding-top:5px;
				  min-height:80px;
				  width:14.28%;
				  position:relative;
				  border-bottom:1px solid #ccc;
				  i{
				  	position:absolute;
				  	right:5px;
				  	top:10px;
				  	font-size:12px;
				  	z-index:10;
				  	color:#d98282;
				  }
				  .day-item{
				  	 box-sizing:border-box;
					 @include flex(column);
					  justify-content:center;
					  align-items:center;
					  font-size:16px;
					  color:#202020;
					  text-align:center; 
					  span{
						margin-top:-1px;
					  }
					  span.color{
					  	background:transparent;
					  	width:100%;
					  	height:25px;
					  	line-height:25px;
					  	margin-bottom:3px;
					  	font-size:5px;
					  	color:#fff;
					  	b{
					  		font-weight:400;
					  		height:25px;
					  		font-size:10px;

					  	}
					  }
				  }
				}
				.empty{
						/*border-right:0px;*/
				}
				/*当天的标记*/
				.currentDay{
				/*	.day-item{
						text-align:center;
						width:40px;
						height:40px;
						border-radius:50%;
						background:#ddd;
						span.solar,span.lunar{
							color:$color-main;
						}
					}*/
						span.solar{
							color:#ccc;
							margin-top:-3px;
						}
						border:2px solid #ccc;
						
					
				}
				/*周末的标记*/
				.weekend{
					color:$color-main;
				}
				/*被点击的标记*/
				.selectedFlag{
/*					.day-item{
						text-align:center;
						width:40px;
						height:40px;
						border-radius:50%;
						background:$color-main;
						span.solar,span.lunar{
							color:#fff;
						}						
					}*/
						span.solar{
							color:$color-main;
							margin-top:-3px;
						}
						border:2px solid $color-main;
						/*border-top:1px solid $color-main;*/
					
				}

			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/Meeting/Calendar.vue